// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"maincontent_mainContent__2yd14","rotated":"maincontent_rotated__3muGq","page":"maincontent_page__1EUQv"};